<template lang="pug">
  nav.TabsBar
    ul
      li
        a(href="#advantage") {{ nowOps.advantages }}
      li
        a(href="#ability") {{ nowOps.abilities }}
      li
        a(href="#solutions") {{ nowOps.solutions }}

</template>

<script>
  import Mixin from '../index.js'
  export default {
    name: "TabsBar",
    mixins: [Mixin],
  };
</script>

<style scoped lang="stylus">
  @import "../../index.styl"
  .TabsBar {
    height 72px
    width 100%
    border-bottom 1px solid #e4e4e4
    background-color #f8f8f8
    
    > ul {
      height 100%
      margin 0 19.479167%
      HStack(center, space-around)
    }
    
    a {
      font-size (18 / 14)rem
      FontSetting("思源黑体 CN Normal")
      color #666666
      width 500px
      text-align center
      
      &:hover {
        color #269bff
      }
    }
    @media (max-width screenWidth) {
      > div {
        margin 0
      }
      a {
        font-size 14px
      }
    }
  }
</style>
